import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    it: {
        translation: {
            welcome: 'Benvenuto nel nostro noleggio bici!',
            ourBikes: 'Le nostre bici',
            contactUs: 'Contattaci',
            managedBy: 'Powered by {{name}}',
            available: 'Disponibile: {{status}}',
            yes: 'Sì',
            no: 'No',
            namePlaceholder: 'Il tuo nome',
            emailPlaceholder: 'La tua email',
            messagePlaceholder: 'Il tuo messaggio',
            submit: 'Invia',
            sending: 'Invio in corso...',
            email: 'Email',
            phone: 'Telefono',
            address: 'Indirizzo',
            home: 'Home',
            error: 'Errore nel caricamento',
            errorRentId: 'rentId non disponibile',
            errorLoadingBikes: 'Errore nel caricamento delle bici o delle immagini',
            vatNumber: 'Partita IVA',
            heroText: 'Esplora Roma in libertà con le nostre bici!',
            heroCta: 'Scopri le nostre bici',
            category: 'Categoria',
            sizes: 'Taglie',
            downloadAppTitle: 'Noleggia le nostre bici!',
            downloadAppText: 'Scarica l’app LoceM e prenota in modo facile e veloce le nostre bici',
            contactSuccess: 'Richiesta di contatto inviata con successo!',
            contactError: 'Errore nell’invio della richiesta. Riprova più tardi.',
            book: 'Prenota',
            googlePlay: 'Google Play',
            appStore: 'App Store',
            FIRST_HALF_MORNING: 'Prima Mattina',
            SECOND_HALF_MORNING: 'Seconda Mattina',
            FIRST_HALF_EVENING: 'Primo Pomeriggio',
            SECOND_HALF_EVENING: 'Secondo Pomeriggio',
            HALF_DAY_MORNING: 'Mattina',
            HALF_DAY_EVENING: 'Pomeriggio',
            FULL_DAY: 'Giornata Intera',
            openingHours: 'Orari di Apertura',
            monday: 'Lunedì',
            tuesday: 'Martedì',
            wednesday: 'Mercoledì',
            thursday: 'Giovedì',
            friday: 'Venerdì',
            saturday: 'Sabato',
            sunday: 'Domenica',
            toggleOpeningHours: 'Espandi/Chiudi orari',
            bikeCard: 'Scheda bici {{name}}',
            multiDayPrices: 'Prezzi per più giorni',
            dailyPrices: 'Prezzi giornalieri',
            dailyPricesToggle: 'Mostra/nascondi prezzi giornalieri',
            multiDayPricesToggle: 'Mostra/nascondi prezzi per più giorni',
            closeModal: 'Chiudi modale',
            day: '1 giorno',
            bikeCardDays: '{{count}} giorni',
            reachUs: 'Raggiungici',
            reachUsAriaLabel: 'Apri mappa per raggiungere {address}',
            bookNow: 'Prenota ora',
            allCategories: 'Tutte le categorie',
            allSizes: 'Tutte le taglie',
            allPrices: 'Tutti i prezzi',
            filterByCategory: 'Filtra per categoria',
            filterBySize: 'Filtra per taglia',
            filterByPrice: 'Filtra per prezzo',
            sortBy: 'Ordina per',
            sortNameAsc: 'Nome (A-Z)',
            sortNameDesc: 'Nome (Z-A)',
            sortPriceAsc: 'Prezzo (crescente)',
            sortPriceDesc: 'Prezzo (decrescente)',
            resetFilters: 'Reimposta filtri',
            scrollToTop: 'Torna all\'inizio della pagina',
            reviewsTitle: 'Cosa dicono i nostri clienti',
            noReviews: 'Nessuna recensione disponibile',
            reviewsError: 'Errore nel caricamento delle recensioni',
            stars: 'stelle',
            viewAllReviews: 'Vedi tutte le recensioni',
            poweredByGoogle: 'Recensioni fornite da Google',
            services: "Servizi",
            ourServices: "I Nostri Servizi",
            servicesNotAvailable: "Nessun servizio disponibile",
            noServices: "Nessun servizio disponibile",
            serviceTitle: "Servizio",
            serviceDescription: "Descrizione non disponibile",
            searchBikesPlaceholder: 'Cerca bici per nome o modello...',
            itemsFound: '{{count}} bici trovate',
            noBikesFound: 'Nessuna bici corrisponde ai filtri selezionati.',
            bookModalPrompt: 'Vuoi noleggiare {{name}}? Scarica l’app LoceM per visualizzare la disponibilità in tempo reale e confermare la prenotazione!',
            scanToDownload: 'Oppure inquadra il QR code con lo smartphone per scaricare l’app LoceM',
            clearSearch: 'Azzera ricerca'
        },
    },
    en: {
        translation: {
            welcome: 'Welcome to our bike rental!',
            ourBikes: 'Our Bikes',
            contactUs: 'Contact Us',
            managedBy: 'Powered by {{name}}',
            available: 'Available: {{status}}',
            yes: 'Yes',
            no: 'No',
            namePlaceholder: 'Your name',
            emailPlaceholder: 'Your email',
            messagePlaceholder: 'Your message',
            submit: 'Send',
            sending: 'Sending...',
            email: 'Email',
            phone: 'Phone',
            address: 'Address',
            home: 'Home',
            error: 'Error loading',
            errorRentId: 'rentId not available',
            errorLoadingBikes: 'Error loading bikes or images',
            vatNumber: 'VAT Number',
            heroText: 'Explore Rome freely with our bikes!',
            heroCta: 'Discover our bikes',
            category: 'Category',
            sizes: 'Sizes',
            downloadAppTitle: 'Rent our bikes!',
            downloadAppText: 'Download the LoceM app and book our bikes quickly and easily!',
            contactSuccess: 'Contact request sent successfully!',
            contactError: 'Error sending the request. Please try again later.',
            book: 'Book',
            googlePlay: 'Google Play',
            appStore: 'App Store',
            FIRST_HALF_MORNING: 'Early Morning',
            SECOND_HALF_MORNING: 'Late Morning',
            FIRST_HALF_EVENING: 'Early Afternoon',
            SECOND_HALF_EVENING: 'Late Afternoon',
            HALF_DAY_MORNING: 'Morning',
            HALF_DAY_EVENING: 'Afternoon',
            FULL_DAY: 'Full Day',
            openingHours: 'Opening Hours',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday',
            toggleOpeningHours: 'Expand/Collapse hours',
            bikeCard: 'Bike card {{name}}',
            multiDayPrices: 'Multi-day prices',
            dailyPrices: 'Daily prices',
            dailyPricesToggle: 'Show/hide daily prices',
            multiDayPricesToggle: 'Show/hide multi-day prices',
            closeModal: 'Close modal',
            day: '1 day',
            bikeCardDays: '{{count}} days',
            reachUs: 'Reach Us',
            reachUsAriaLabel: 'Open map to reach {address}',
            bookNow: 'Book Now',
            allCategories: 'All categories',
            allSizes: 'All sizes',
            allPrices: 'All prices',
            filterByCategory: 'Filter by category',
            filterBySize: 'Filter by size',
            filterByPrice: 'Filter by price',
            sortBy: 'Sort by',
            sortNameAsc: 'Name (A-Z)',
            sortNameDesc: 'Name (Z-A)',
            sortPriceAsc: 'Price (low to high)',
            sortPriceDesc: 'Price (high to low)',
            resetFilters: 'Reset filters',
            scrollToTop: 'Scroll to the top of the page',
            reviewsTitle: 'What our customers say',
            noReviews: 'No reviews available',
            reviewsError: 'Error loading reviews',
            stars: 'stars',
            viewAllReviews: 'View all reviews',
            poweredByGoogle: 'Reviews provided by Google',
            services: "Services",
            ourServices: "Our Services",
            servicesNotAvailable: "No services available",
            noServices: "No services available",
            serviceTitle: "Service",
            serviceDescription: "Description not available",
            searchBikesPlaceholder: 'Search bikes by name or model...',
            itemsFound: '{{count}} bikes found',
            noBikesFound: 'No bikes match the selected filters.',
            bookModalPrompt: 'Want to rent {{name}}? Download the LoceM app to check real-time availability and confirm your booking!',
            scanToDownload: 'Or scan the QR code with your smartphone to download the LoceM app',
            clearSearch: 'Clear search'
        },
    },
    de: {
        translation: {
            welcome: 'Willkommen in unserer Fahrradvermietung!',
            ourBikes: 'Unsere Fahrräder',
            contactUs: 'Kontaktiere uns',
            managedBy: 'Powered by {{name}}',
            available: 'Verfügbar: {{status}}',
            yes: 'Ja',
            no: 'Nein',
            namePlaceholder: 'Dein Name',
            emailPlaceholder: 'Deine E-Mail',
            messagePlaceholder: 'Deine Nachricht',
            submit: 'Senden',
            sending: 'Wird gesendet...',
            email: 'E-Mail',
            phone: 'Telefon',
            address: 'Adresse',
            home: 'Home',
            error: 'Fehler beim Laden',
            errorRentId: 'rentId nicht verfügbar',
            errorLoadingBikes: 'Fehler beim Laden der Fahrräder oder Bilder',
            vatNumber: 'Umsatzsteuer-ID',
            heroText: 'Entdecke Rom frei mit unseren Fahrrädern!',
            heroCta: 'Entdecke unsere Fahrräder',
            category: 'Kategorie',
            sizes: 'Größen',
            downloadAppTitle: 'Miete unsere Fahrräder!',
            downloadAppText: 'Lade die LoceM-App herunter und buche unsere Fahrräder schnell und einfach!',
            contactSuccess: 'Kontaktanfrage erfolgreich gesendet!',
            contactError: 'Fehler beim Senden der Anfrage. Bitte versuche es später erneut.',
            book: 'Buchen',
            googlePlay: 'Google Play',
            appStore: 'App Store',
            FIRST_HALF_MORNING: 'Früher Morgen',
            SECOND_HALF_MORNING: 'Später Vormittag',
            FIRST_HALF_EVENING: 'Früher Nachmittag',
            SECOND_HALF_EVENING: 'Später Nachmittag',
            HALF_DAY_MORNING: 'Vormittag',
            HALF_DAY_EVENING: 'Nachmittag',
            FULL_DAY: 'Ganzer Tag',
            openingHours: 'Öffnungszeiten',
            monday: 'Montag',
            tuesday: 'Dienstag',
            wednesday: 'Mittwoch',
            thursday: 'Donnerstag',
            friday: 'Freitag',
            saturday: 'Samstag',
            sunday: 'Sonntag',
            toggleOpeningHours: 'Öffnungszeiten ein-/ausklappen',
            bikeCard: 'Fahrradkarte {{name}}',
            multiDayPrices: 'Preise für mehrere Tage',
            dailyPrices: 'Tagespreise',
            dailyPricesToggle: 'Tagespreise anzeigen/ausblenden',
            multiDayPricesToggle: 'Preise für mehrere Tage anzeigen/ausblenden',
            closeModal: 'Modal schließen',
            day: '1 Tag',
            bikeCardDays: '{{count}} Tage',
            reachUs: 'Erreichen Sie uns',
            reachUsAriaLabel: 'Karte öffnen, um {address} zu erreichen',
            bookNow: 'Jetzt buchen',
            allCategories: 'Alle Kategorien',
            allSizes: 'Alle Größen',
            allPrices: 'Alle Preise',
            filterByCategory: 'Nach Kategorie filtern',
            filterBySize: 'Nach Größe filtern',
            filterByPrice: 'Nach Preis filtern',
            sortBy: 'Sortieren nach',
            sortNameAsc: 'Name (A-Z)',
            sortNameDesc: 'Name (Z-A)',
            sortPriceAsc: 'Preis (aufsteigend)',
            sortPriceDesc: 'Preis (absteigend)',
            resetFilters: 'Filter zurücksetzen',
            scrollToTop: 'Zum Anfang der Seite scrollen',
            reviewsTitle: 'Was unsere Kunden sagen',
            noReviews: 'Keine Bewertungen verfügbar',
            reviewsError: 'Fehler beim Laden der Bewertungen',
            stars: 'Sterne',
            viewAllReviews: 'Alle Bewertungen ansehen',
            poweredByGoogle: 'Bewertungen von Google bereitgestellt',
            services: "Dienstleistungen",
            ourServices: "Unsere Dienstleistungen",
            servicesNotAvailable: "Keine Dienstleistungen verfügbar",
            noServices: "Keine Dienstleistungen verfügbar",
            serviceTitle: "Dienst",
            serviceDescription: "Beschreibung nicht verfügbar",
            searchBikesPlaceholder: 'Fahrräder nach Name oder Modell suchen...',
            itemsFound: '{{count}} Fahrräder gefunden',
            noBikesFound: 'Keine Fahrräder entsprechen den ausgewählten Filtern.',
            bookModalPrompt: 'Möchten Sie {{name}} mieten? Laden Sie die LoceM-App herunter, um die Verfügbarkeit in Echtzeit zu prüfen und Ihre Buchung zu bestätigen!',
            scanToDownload: 'Oder scannen Sie den QR-Code mit Ihrem Smartphone, um die LoceM-App herunterzuladen',
            clearSearch: 'Suche löschen'
        },
    },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'it',
        supportedLngs: ['it', 'en', 'de'],
        nonExplicitSupportedLngs: true,
        load: 'languageOnly',
        detection: {
            order: ['querystring', 'localStorage', 'navigator'],
            lookupQuerystring: 'lang',
            lookupLocalStorage: 'i18nextLng',
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
